import '@/styles/object/project/_room.scss';
import '@/styles/object/project/_room_membership.scss';
import '@/styles/object/project/_room_thread.scss';
import '@/styles/object/component/_Modal.scss';
import '@/styles/overrides/_main-h-full.scss';
import '@/styles/overrides/_newPost_fab-hidden.scss';
import ThreadImageInput from '@/javascripts/components/ThreadImageInput';
import ImageZoomer from '@/javascripts/components/ImageZoomer';
import { bindExternalLinkModalEvent } from '@/javascripts/external_link_modal';
import { mountReactComponents } from '@/utils/react_mount';
import { communityComponents } from '@/components/mountable/registry';

if (!window.Coorum) {
  window.Coorum = {};
}
window.Coorum.ThreadImageInput = ThreadImageInput;
window.Coorum.ImageZoomer = ImageZoomer;
window.Coorum.bindExternalLinkModalEvent = bindExternalLinkModalEvent;

$(() => {
  new window.Coorum.ThreadImageInput({
    imageContainerSelectors: '.js-thread-image-container',
    fileInputSelectors: '.js-thread-file-input',
    fileInputIconSelectors: '.js-thread-file-input-icon',
  });
  new window.Coorum.ImageZoomer().setGeneralEvent();

  initializeThreadsMutationObserver();
  initializeFormMutationObserver();
  initializeMainContentClass();
  initializeBreadcrumbClass();
  initializeTabs();
  initializeScroll();
  initializePaginate();
  initializeTriggersModalJoin();
  initializeTriggersModalClose();
});

function initializeThreadsMutationObserver() {
  const mutationObserver = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      Array.from(mutation.addedNodes)
        .filter(node => node.nodeType === Node.ELEMENT_NODE)
        .forEach(node => {
          // 動的に追加/再描画された投稿の React いいねボタンをマウントする
          // （もっと見る / 参加で likeable 化 / 新規投稿）。基盤は load 時 1 回しか走査しないため。
          mountReactComponents(communityComponents, node as HTMLElement);
          initializeScroll();
          initializePaginate();
          initializeTriggersModalJoin(node as HTMLElement);
        });
    });
  });
  const observeTarget = document.querySelector('#js-threads-wrapper');
  if (observeTarget) {
    mutationObserver.observe(observeTarget, { childList: true, subtree: true });
  }
}

function initializeFormMutationObserver() {
  const mutationObserver = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      Array.from(mutation.addedNodes)
        .filter(node => node.nodeType === Node.ELEMENT_NODE)
        .forEach(node => {
          new window.Coorum.ThreadImageInput({
            rootElement: node as HTMLElement,
            imageContainerSelectors: '.js-thread-image-container',
            fileInputSelectors: '.js-thread-file-input',
            fileInputIconSelectors: '.js-thread-file-input-icon',
          });
          initializeTriggersModalJoin(node as HTMLElement);
        });
    });
  });
  const observeTarget = document.querySelector('.js-form');
  if (observeTarget) {
    mutationObserver.observe(observeTarget, { childList: true, subtree: true });
  }
}

function initializeMainContentClass() {
  const mainContent = document.querySelector('.main-content');
  mainContent?.classList.add('pb-0', 'md:pb-8');
}

function initializeBreadcrumbClass() {
  const breadcrumb = document.querySelector('.breadcrumb');
  breadcrumb?.classList.add('px-4', 'py-2', 'md:px-0', 'md:py-0', 'my-0');
}

function initializeTabs() {
  const mainTab = document.querySelector('.js-main-tab');
  const asideTab = document.querySelector('.js-aside-tab');
  const tabs = [mainTab, asideTab].filter(Boolean) as HTMLElement[];
  const mainSection = document.querySelector('.js-main');
  const asideSection = document.querySelector('.js-aside');
  const activeTabClass = ['p-room-card__title', 'border-0', 'border-b-2', 'border-solid', 'u-border-main-or-coorum-yellow'];

  tabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      tabs.forEach(t => t.classList.remove(...activeTabClass));
      tab.classList.add(...activeTabClass);
    });
  });

  mainTab?.addEventListener('click', () => {
    asideSection?.classList.add('hidden');
    mainSection?.classList.remove('hidden');
  });

  asideTab?.addEventListener('click', () => {
    mainSection?.classList.add('hidden');
    asideSection?.classList.remove('hidden');
  });
}

function initializeScroll() {
  const scrollBtn = document.querySelector('#js-scroll-btn');
  const scrollableDiv = document.querySelector('#js-threads-wrapper');

  scrollableDiv?.addEventListener('scroll', () => {
    scrollBtn?.classList.remove('hidden');
  });

  scrollBtn?.addEventListener('click', () => {
    if (scrollableDiv) {
      const divHeight = scrollableDiv.scrollHeight;
      scrollableDiv.scrollTo({ top: divHeight, behavior: 'smooth' });
    }
  });
}

function initializePaginate() {
  const paginateBtn = document.querySelector('#js-paginate-btn');
  if (paginateBtn) {
    const loadingImg = document.querySelector('#js-paginate-loading-img');
    paginateBtn.addEventListener('click', function () {
      paginateBtn.classList.add('hidden');
      loadingImg?.classList.remove('hidden');
    });
  }
}

function initializeTriggersModalJoin(rootElement: Document | HTMLElement = document) {
  const triggers = rootElement.querySelectorAll('.js-trigger-modal-join');
  const attention = document.querySelector('#js-attention');
  const modal = document.querySelector('#js-modal-join');

  triggers.forEach(function (trg) {
    trg.addEventListener('click', function () {
      attention?.classList.add('md:block');
      modal?.classList.remove('hidden');
    });
  });
}

function initializeTriggersModalClose(rootElement: Document | HTMLElement = document) {
  rootElement.querySelectorAll('.js-btn-modal-close').forEach(btn => {
    btn.addEventListener('click', function (this: HTMLElement) {
      const modal = this.closest('.js-modal');
      if (modal) {
        modal.classList.add('hidden');
      }
    });
  });
}
